import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { ESettingsWorkspaceTab } from '../ESettingsWorkspaceTab';
import { TabSettingsWorkspaceWrapper } from '../_base/TabSettingsWorkspaceWrapper';
import { WorkspaceAvatarReadOnly } from '../_base/WorkspaceAvatarReadOnly';
import { ButtonWorkspaceLeave } from './_buttons/ButtonWorkspaceLeave';

export const TabSettingsWorkspaceGeneralReadOnly = () => {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { workspace_current, current_workspace_user } = use_slice_workspace(['workspace_current', 'current_workspace_user']);

  if (workspace_current.user_id_owner == current_workspace_user.user_id) return <></>;

  return (
    <TabSettingsWorkspaceWrapper type={ESettingsWorkspaceTab.GENERAL}>
      <div className="flex flex-col justify-start items-start mt-2 gap-3 text-page-foreground">
        <span className="text-xl">{t(i18n_page_settings_workspace.tabs.general.title)}</span>
        <div className="flex flex-col items-start justify-start gap-5">
          <div className="flex items-center gap-2">
            <WorkspaceAvatarReadOnly className="!size-[5rem] !rounded-xl" workspace={workspace_current} />
            <span>
              Workspace: <span className="font-bold">{workspace_current.name}</span>
            </span>
          </div>
          <ButtonWorkspaceLeave />
        </div>
      </div>
    </TabSettingsWorkspaceWrapper>
  );
};
